import { Badge } from "@/components/ui/badge";

export const materialEinheiten = [
  "Stück", "Liter", "ml", "kg", "g", "Meter", "cm", "m²",
  "Paar", "Satz", "Set", "Packung", "Dose", "Flasche", "Karton"
];

export const getStatusBadge = (status) => {
  const styles = {
    offen: "bg-blue-100 text-blue-800",
    in_bearbeitung: "bg-orange-100 text-orange-800",
    erledigt: "bg-green-100 text-green-800"
  };
  const labels = {
    offen: "Offen",
    in_bearbeitung: "In Bearbeitung",
    erledigt: "Erledigt"
  };
  return <Badge className={`${styles[status]} font-medium`}>{labels[status] || status}</Badge>;
};

export const calculateTotals = (tasks) => {
  const totalTime = tasks.reduce((sum, t) => sum + (t.time_minutes || 0), 0);
  const totalCost = tasks.reduce((sum, t) => {
    if (t.materialien && t.materialien.length > 0) {
      return sum + t.materialien.reduce((mSum, m) => mSum + (m.kosten || 0), 0);
    }
    return sum + (t.material_cost || 0);
  }, 0);
  const completedTasks = tasks.filter(t => t.completed).length;
  return { totalTime, totalCost, completedTasks, totalTasks: tasks.length };
};

export const formatMinutes = (minutes) => {
  if (!minutes) return "0 min";
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return hours > 0 ? `${hours}h ${mins}min` : `${mins} min`;
};

export const startVoiceRecognition = (fieldType, setter, currentValue = "", setIsListening, setActiveField) => {
  if (!('webkitSpeechRecognition' in window || 'SpeechRecognition' in window)) {
    return;
  }
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  const recognition = new SpeechRecognition();
  recognition.lang = 'de-DE';
  recognition.continuous = false;
  recognition.interimResults = false;
  setIsListening(true);
  setActiveField(fieldType);
  recognition.onresult = (event) => {
    const transcript = event.results[0][0].transcript;
    const newValue = currentValue ? `${currentValue} ${transcript}` : transcript;
    setter(newValue);
    setIsListening(false);
    setActiveField(null);
  };
  recognition.onerror = () => { setIsListening(false); setActiveField(null); };
  recognition.onend = () => { setIsListening(false); setActiveField(null); };
  recognition.start();
};
